import React, { useEffect, useState } from "react";
import { fetchRegime } from "../hooks/useSheets";

// KR 시장 레짐 게이지 — 모멘텀장 vs 평균회귀장 (연구레포 CI가 매일 계산 → Google 시트 → 여기)
// 주신호: 시장 60일 추세 z (워크포워드 OOS IC+0.30, t+3.6, 적중63% / 12년 비중첩)
// 보조: vol 크래시존 플래그(고vol서 모멘텀 크래시)
export default function RegimeGauge() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    fetchRegime()
      .then((j) => (j && !j.error && j.gauge !== undefined ? setD(j) : setErr(true)))
      .catch(() => setErr(true));
  }, []);

  if (err || !d) return null;

  const mom = d.regime === "모멘텀장";
  const color = mom ? "#1a9e5f" : "#d1495b";
  const bg = mom ? "#eaf7f0" : "#fdeef0";
  // 게이지 위치: z-score를 -3..+3 → 0..100%
  const pos = Math.max(0, Math.min(100, ((d.gauge + 3) / 6) * 100));

  const cell = { flex: 1, minWidth: 120 };
  const label = { fontSize: 11, color: "#888", marginBottom: 2 };
  const val = { fontSize: 14, fontWeight: 700, color: "#1a1a2e" };

  return (
    <div style={{ background: bg, border: `1px solid ${color}33`, borderRadius: 12, padding: "16px 20px", marginBottom: 20 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
        <div>
          <div style={{ fontSize: 11, color: "#888", letterSpacing: 0.3 }}>
            KR 시장 레짐 {d.crash_zone && <span style={{ color: "#d1495b", fontWeight: 700 }}>· ⚠️ 고vol 크래시존</span>}
          </div>
          <div style={{ fontSize: 22, fontWeight: 800, color }}>
            {mom ? "📈" : "🔄"} {d.regime} <span style={{ fontSize: 13, color: "#888", fontWeight: 600 }}>({d.strength})</span>
          </div>
          <div style={{ fontSize: 13, color: "#444", marginTop: 2 }}>{d.playbook}</div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: 26, fontWeight: 800, color }}>{d.gauge > 0 ? "+" : ""}{d.gauge}</div>
          <div style={{ fontSize: 11, color: "#888" }}>게이지 z (역사 {Math.round(d.pctile * 100)}%)</div>
        </div>
      </div>

      {/* 게이지 바: 회귀 ← → 모멘텀 */}
      <div style={{ position: "relative", height: 6, borderRadius: 3, marginTop: 12,
                    background: "linear-gradient(90deg,#d1495b 0%,#e8e8e8 50%,#1a9e5f 100%)" }}>
        <div style={{ position: "absolute", left: `${pos}%`, top: -4, width: 3, height: 14,
                      background: "#1a1a2e", borderRadius: 2, transform: "translateX(-50%)" }} />
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10, color: "#aaa", marginTop: 3 }}>
        <span>← 평균회귀(극단 페이드)</span><span>모멘텀/발산(승자 놔두기) →</span>
      </div>

      {/* 서브 지표 */}
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginTop: 14, paddingTop: 12, borderTop: "1px solid #0001" }}>
        <div style={cell}><div style={label}>시장 60일 추세</div><div style={val}>{(d.trend60d * 100).toFixed(1)}%</div></div>
        <div style={cell}><div style={label}>변동성(연율)</div><div style={val}>{(d.vol_ann * 100).toFixed(0)}% <span style={{ fontSize: 11, color: d.crash_zone ? "#d1495b" : "#888" }}>({Math.round(d.vol_pctile * 100)}%p)</span></div></div>
        <div style={cell}><div style={label}>검증(OOS)</div><div style={val}>IC {d.oos_ic} · 적중 {Math.round(d.oos_hit * 100)}%</div></div>
        <div style={cell}><div style={label}>기준일 / 종목수</div><div style={val}>{d.date} · {d.n_stocks}</div></div>
      </div>
    </div>
  );
}
